import { createClient } from '@/utils/supabase/client';

// Export singleton instance using SSR-friendly client
// This ensures compatibility with existing code while using the correct client implementation
export const supabase = createClient();

export interface UserProfile {
  id: string;
  name?: string;
  email?: string;
  created_at?: string;
  last_login?: string;
  is_admin?: boolean;
}

export interface BlogPost {
  id: string;
  title: string;
  slug: string;
  content: string;
  excerpt?: string;
  seo_title?: string;
  seo_description?: string;
  seo_keywords?: string;
  featured_image_url?: string;
  featured_image_alt_text?: string;
  category?: string;
  tags?: string;
  reading_time?: number;
  view_count?: number;
  published_at?: string;
  author_id: string;
  created_at?: string;
  updated_at?: string;
  is_published?: boolean;
  author?: UserProfile;
}

export interface Plan {
  id: string;
  user_id: string;
  dimensions?: string;
  location?: string;
  sunlight?: string;
  budget?: string;
  objective?: string;
  details?: string;
  ai_response?: string;
  created_at?: string;
}

